import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Acciones from './Accion';


interface AccionTableProps {
  data: Acciones[];
  columns:  TableColumn<Acciones>[];
  customStyles: Record<string, any>;
}

const AccionTable: React.FC<AccionTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Acciones>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default AccionTable;